/* globals angular */
(function () {
  'use strict';

  var charts = {
    template: require('./charts.html'),
    controller: 'ChartsCtrl',
  };

  angular
    .module('mandaeApp')
    .component('charts', charts)
    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider
        .state('charts', {
          parent: 'historico',
          authenticate: true,
          component: 'charts',
          url: '/charts',
        });
    }]);

}());
